export const SND_SEARCH_COUNTRY_REQUEST =
  '@@LeftSidebarContent/SND_SEARCH_COUNTRY_REQUEST';
export const SND_SEARCH_COUNTRY_SUCCESS =
  '@@LeftSidebarContent/SND_SEARCH_COUNTRY_SUCCESS';
export const SND_SEARCH_COUNTRY_FAILURE =
  '@@LeftSidebarContent/SND_SEARCH_COUNTRY_FAILURE';

export const FETCH_SND_COUNTRY_DETAILS_REQUEST =
  '@@LeftSidebarContent/FETCH_SND_COUNTRY_DETAILS_REQUEST';
export const FETCH_SND_COUNTRY_DETAILS_SUCCESS =
  '@@LeftSidebarContent/FETCH_SND_COUNTRY_DETAILS_SUCCESS';
export const FETCH_SND_COUNTRY_DETAILS_FAILURE =
  '@@LeftSidebarContent/FETCH_SND_COUNTRY_DETAILS_FAILURE';

export const FETCH_SND_REGION_DETAILS_REQUEST =
  '@@LeftSidebarContent/FETCH_SND_REGION_DETAILS_REQUEST';
export const FETCH_SND_REGION_DETAILS_SUCCESS =
  '@@LeftSidebarContent/FETCH_SND_REGION_DETAILS_SUCCESS';
export const FETCH_SND_REGION_DETAILS_FAILURE =
  '@@LeftSidebarContent/FETCH_SND_REGION_DETAILS_FAILURE';

export const FETCH_SND_AREA_DETAILS_REQUEST =
  '@@LeftSidebarContent/FETCH_SND_AREA_DETAILS_REQUEST';
export const FETCH_SND_AREA_DETAILS_SUCCESS =
  '@@LeftSidebarContent/FETCH_SND_AREA_DETAILS_SUCCESS';
export const FETCH_SND_AREA_DETAILS_FAILURE =
  '@@LeftSidebarContent/FETCH_SND_AREA_DETAILS_FAILURE';

export const FETCH_SND_TERRITORY_DETAILS_REQUEST =
  '@@LeftSidebarContent/FETCH_SND_TERRITORY_DETAILS_REQUEST';
export const FETCH_SND_TERRITORY_DETAILS_SUCCESS =
  '@@LeftSidebarContent/FETCH_SND_TERRITORY_DETAILS_SUCCESS';
export const FETCH_SND_TERRITORY_DETAILS_FAILURE =
  '@@LeftSidebarContent/FETCH_SND_TERRITORY_DETAILS_FAILURE';

export const INIT_PARTNER_REPORTS_FILTER_STATE = {
  partner_update: true,
  partner_transaction: false
};

export const INIT_FILTERING_STATE = {
  distribution_house: false,
  high_balance_agents: false,
  dh_stock_balance_lifting: false,
  dh_stock_progress: false,
  dh_stock_balance_agent: false,
  agent_with_transaction: false,
  agent_without_transaction: false,
  leading_agents: false,
  leading_agent_tpv: false,
  leading_agent_category: false,
  milking_agent: false,
  active_agents: false,
  active_agent_without_disbursement_cashout: false,
  active_agent_partner_payment_only: false
};

export const CHANGE_FILTERING_STATE =
  '@@LeftSidebarContent/CHANGE_FILTERING_STATE';
